import { render } from "./edit.vue?vue&type=template&id=1b366903"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
script.render = render

export default script